import dnsZoneFile from "refractor/dns-zone-file";
export default dnsZoneFile;